const initialize = (sectionData) => {
  const itemsEl = document.querySelector(".gd-cart-items");
  itemsEl.querySelectorAll(".gd-remove-button").forEach((removeButton) => {
    removeButton.addEventListener("click", async () => {
      const line = removeButton.dataset.line;
      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          line: Number(line),
          quantity: 0,
        }),
      });
      location.reload();
    });
  });

  itemsEl.querySelectorAll(".gd-quantity-minus-button").forEach((minusButton) => {
    minusButton.addEventListener("click", async () => {
      const inputEl = minusButton.parentElement.querySelector("input");
      const line = inputEl.dataset.line;
      const quantity = Math.max(0, parseInt(inputEl.value) - 1);
      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          line: Number(line),
          quantity: quantity,
        }),
      });
      location.reload();
    });
  });

  itemsEl.querySelectorAll(".gd-quantity-plus-button").forEach((plusButton) => {
    plusButton.addEventListener("click", async () => {
      const inputEl = plusButton.parentElement.querySelector("input");
      const line = inputEl.dataset.line;
      const quantity = Math.max(0, parseInt(inputEl.value) + 1);
      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          line: Number(line),
          quantity: quantity,
        }),
      });
      location.reload();
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  if (window.gd.template != "cart" || !window.gd.sections) {
    return;
  }
  const sectionData = window.gd.sections.find((s) => s.type == "cart");
  if (!sectionData) {
    return;
  }
  initialize(sectionData);
});
